import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { H1 } from '@hobs/components/Headings';
import Panel from '@hobs/components/Panel';
import { GhostButton, RaisedButton } from '@hobs/components/Buttons';
import PageActions from '@hobs/components/PageActions';
import { getTokenData } from '@hobs/auth/utils';
import './TermsAndConditions.scss';

import { getExerciseTerms, acceptExerciseTerms } from '../../actions/exercises';

class TermsAndConditions extends PureComponent {
  constructor() {
    super();
    this.terms = React.createRef();
  }

  componentDidMount() {
    this.props.getExerciseTerms();
  }

  async accept() {
    const results = await this.props.acceptExerciseTerms();

    if (results.success) {
      return this.props.history.push('/');
    }

    return results;
  }

  render() {
    const { t } = this.props;

    const token = localStorage.getItem('token');

    return getTokenData(token).AgreedToExercise === 'True' ? (
      <Redirect to="/" />
    ) : (
      <div ref={this.terms} className="terms-and-conditions">
        <div className="terms-and-conditions--heading">
          <H1>{t('Terms and Conditions')}</H1>
        </div>
        <Panel>
          <div
            className="terms-and-conditions--panel-content"
            dangerouslySetInnerHTML={{ __html: this.props.page }}
          />
        </Panel>
        <PageActions
          container={this.terms.current}
          wrapperClass="terms-and-conditions--page-actions"
        >
          <div className="terms-and-conditions--action-text">
            {t('Please accept the Terms and Conditions to proceed.')}
          </div>
          <div className="terms-and-conditions--action-buttons">
            <GhostButton to={'/logout'} large>
              {t('Decline')}
            </GhostButton>
            <RaisedButton onClick={this.accept.bind(this)} large>
              {t('Accept')}
            </RaisedButton>
          </div>
        </PageActions>
      </div>
    );
  }
}

TermsAndConditions.propTypes = {
  page: PropTypes.string,
  history: PropTypes.object,
  getExerciseTerms: PropTypes.func,
  acceptExerciseTerms: PropTypes.func,
  t: PropTypes.func
};

const mapStateToProps = state => ({
  page: state.exercises.currentTermPage
});

const mapDispatchToProps = {
  getExerciseTerms,
  acceptExerciseTerms
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withRouter(TermsAndConditions)));
